export class AuthError extends Error {
  constructor(message) {
    super(message);
    this.name = "AuthError";
  }
}

export const authedFetch = async (url: string, options: RequestInit = {}) => {
  const token = JSON.parse(localStorage.getItem("token"));

  const headers = {
    ...options.headers,
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    throw new AuthError("Unauthorized");
  }

  if (!response.ok) {
    const errorText = await response.text();
    console.error(`Failed to fetch ${url}. Status: ${response.status}. Response: ${errorText}`);
    throw new Error(`Failed to fetch ${url}`);
  }

  // Check if response is empty before trying to parse JSON
  const text = await response.text();
  return text ? JSON.parse(text) : {};
};

export const checkForAdmin = async (userId: string) => {
  try {
    const userData = await authedFetch(`api/auth/checkForAdmin`, {
      method: "POST",
      body: JSON.stringify(userId),
    });
    return userData;
  } catch (error) {
    console.error("Error check for Admin:", error);
    throw new Error("An error occurred while check for admin");
  }
};

export const deleteUser = async (userId: string) => {
  try {
    const userData = await authedFetch(`api/requests/deleteUser`, {
      method: "POST",
      body: JSON.stringify(userId),
    });
    return userData;
  } catch (error) {
    console.error("Error delete user:", error);
    throw new Error("An error occurred while delete user");
  }
};

export const getCountries = async () => {
  try {
    const data = await authedFetch(`api/requests/getCountries`, {
      method: "POST",
    });
    return data;
  } catch (error) {
    console.error("Error getting countries:", error);
    throw new Error("An error occurred while get countries");
  }
};

export const getCountryDataByGroupId = async (groupId) => {
  try {
    const data = await authedFetch(`api/requests/getCountryDataByGroupId`, {
      method: "POST",
      body: JSON.stringify(groupId),
    });
    return data;
  } catch (error) {
    console.error("Error getting country data:", error);
    throw new Error("An error occurred while get country data");
  }
};

export const getHeadquarterNameById = async (headquarterId) => {
  try {
    const data = await authedFetch(`api/requests/getHeadquarterNameById`, {
      method: "POST",
      body: JSON.stringify(headquarterId),
    });
    return data.name;
  } catch (error) {
    console.error("Error getting headquarter name:", error);
    throw new Error("An error occurred while get headquarter name");
  }
};

export const getHeadquarterNameByGroupId = async (groupId) => {
  try {
    const data = await authedFetch(
      `api/requests/getHeadquarterNameByGroupId`,
      {
        method: "POST",
        body: JSON.stringify(groupId),
      }
    );
    return data.name;
  } catch (error) {
    console.error("Error getting headquarter name:", error);
    throw new Error("An error occurred while get headquarter name");
  }
};

export const getGroupNameById = async (groupId) => {
  try {
    const data = await authedFetch(`api/requests/getGroupNameById`, {
      method: "POST",
      body: JSON.stringify(groupId),
    });
    return data.name;
  } catch (error) {
    console.error("Error getting group name:", error);
    throw new Error("An error occurred while get group name");
  }
};

export const getGroups = async () => {
  try {
    const data = await authedFetch(`api/requests/getGroups`, {
      method: "POST",
    });
    return data;
  } catch (error) {
    console.error("Error getting groups:", error);
    throw new Error("An error occurred while get groups");
  }
};

export const getHeadquarters = async () => {
  try {
    const data = await authedFetch(`api/requests/getHeadquarters`, {
      method: "POST",
    });
    return data;
  } catch (error) {
    console.error("Error getting headquarter:", error);
    throw new Error("An error occurred while get headquarter");
  }
};

export const getGroupsInHeadquarter = async (headquarterId) => {
  try {
    const data = await authedFetch(`api/requests/getGroupsInHeadquarter`, {
      method: "POST",
      body: JSON.stringify(headquarterId),
    });
    return data;
  } catch (error) {
    console.error("Error getting groups:", error);
    throw new Error("An error occurred while get groups");
  }
};

export const getUserDataById = async (userId) => {
  try {
    const data = await authedFetch(`api/requests/getUserDataById`, {
      method: "POST",
      body: JSON.stringify(userId),
    });
    return data;
  } catch (error) {
    console.error("Error getting user data:", error);
    throw new Error("An error occurred while get user data");
  }
};

